module.exports = __webpack_public_path__ + "static/img/banner.c6787e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/banner.jpg
// module id = R0SL
// module chunks = 1